import createStore from 'unistore';
import cache, { globaleStore } from './cache';
import {
  API as _API,
  TOKEN as _TOKEN,
  PAYMODE as _PAYMODE,
  FLOW as _FLOW,
  ELEMENT_PAYMODE as _ELEMENT_PAYMODE,
  EMI_SUBVENTION_STRATEGY as _EMI_SUBVENTION_STRATEGY
} from '../../../common/index.api';
import { handlePostData, postInWindow, _getFormHtmlNode } from '../utils/formPost';
import {
  getKey,
  callOnce,
  parseData,
  money,
  applyMerchPref,
  paymentFlow,
  errorObject,
  isMgvSufficient,
  isAddNPay,
  isInsufficientBalance,
  isHybridOrAddNPay,
  defaultSelected,
  cloneObject,
  isObject,
  notifyMerchant,
  iframePath,
  setUpiIntentMwebDisplay,
  generateUUID,
  getStaticPath,
  isFunction,
  isNullOrUndefined,
  isHybridOrAddNPayWithSufficientWalletBalance
} from '../utils/common';
import CONSTANT, { CACHE, EVENTS, GLOBAL_STORE } from '../utils/constants';
import ERRORS from '../utils/error-codes';
import { set } from './merchant-config';
import { PAYMENT_FLOW } from '../../../common/src/constant';
import { EVENT, log, init as initLogger } from './logger';
import { customPay, getAsyncPayload } from '../utils/token';
import {
  getDataFromLocalStorage,
  processLocalStorage,
  savingUsedPaymodeInLocalStorage
} from './localStorage';
import { isWebViewFlow, merchantServerEndpoint } from '../../../common/src/utils/common';

let _mid;
/**
 * All the functions that are not member functions can be added here
 */

const getTokenData = cache => {
  return cache.getData(CACHE.TOKEN_DATA, {
    token: '',
    tokenType: _TOKEN.GUEST
  });
};

const updateTokens = cache => {
  const token = getTokenData(cache);
  const context = this;

  if (context.removeConfig) {
    context.removeConfig();
  }
  context.removeConfig = cache.getData(CACHE.API).middleware.add(o => {
    const options = o;
    if (!getKey(options.data, 'head')) {
      throw new Error('current options are mandatory');
    }

    options.data.head = { ...options.data.head, ...token };
    return options;
  });
};

const nonMethods = {
  setData(cache, checkoutElementPayMode, merchantConfig, paymentInstrumentsResponse) {
    const paymentInstruments = paymentInstrumentsResponse.body;
    const config = merchantConfig.configuration;
    cache.setData(
      cache.setDataCACHE.RAW_INSTRUMENTS,
      JSON.parse(JSON.stringify(paymentInstruments))
    );
    parseData(paymentInstruments, cache, checkoutElementPayMode);
    cache.setData(CACHE.PAYMENT_OPTIONS, paymentInstruments);
    if (!config || !config.data) {
      config.data = {};
    }
    config.data.token = paymentInstruments.guestToken;
    config.merchant.mid = _mid;
    config.data.tokenType = _TOKEN.GUEST;
    cache.setData(CACHE.GUEST_TOKEN, config.data.token);
    cache.setData(CACHE.MERCHANT_CONFIG, set(config));
    if (getKey(paymentInstruments, 'guestToken')) {
      cache.setData(CACHE.TOKEN_DATA, {
        token: paymentInstruments.guestToken,
        tokenType: _TOKEN.GUEST
      });
      updateTokens.call(this, cache);
    }
  }
};

const getInstrumentForTxnToken = (function _getInstrumentForTxnToken() {
  const _initData = {
    inProgressPromise: null,
    data: null,
    orderId: null,
    token: null
  };

  function _getGlobalStoreFpoResponse() {
    const fpoResponse = (globaleStore.getState() || {})[GLOBAL_STORE.FPO_UPDATED_RESPONSE];
    if (fpoResponse) {
      return {
        head: fpoResponse.head,
        body: fpoResponse.cashierData
      };
    }

    return null;
  }

  return (api, data, useCached) => {
    if (data.token) {
      if (
        useCached &&
        _initData.orderId === data.orderId &&
        _initData.token === data.token &&
        (_initData.inProgressPromise || _initData.data)
      ) {
        return (
          _initData.inProgressPromise ||
          Promise.resolve(_getGlobalStoreFpoResponse() || _initData.data)
        );
      }

      let resolveInProgress;
      let rejectInProgress;
      _initData.inProgressPromise = new Promise((localResolve, localReject) => {
        resolveInProgress = localResolve;
        rejectInProgress = localReject;
      });

      _initData.data = null;
      _initData.orderId = data.orderId;
      _initData.token = data.token;

      data.applyPaymentOffer = 'true';
      data.fetchAllPaymentOffers = 'true';
      data.mid = _mid;
      globaleStore.setState({ [GLOBAL_STORE.FPO_UPDATED_RESPONSE]: null });
      return api
        .tokenPaymodes(data)
        .then(response => {
          _initData.data = response;
          resolveInProgress(response);
          _initData.inProgressPromise = null;
          return response;
        })
        .catch(error => {
          rejectInProgress(error);
          _initData.inProgressPromise = null;
          throw error;
        });
    }
    throw new Error('provide token to get the paymodes for the Txn token');
  };
})();

const _init = function initialize(mConfig, self) {
  const config = set(mConfig, true);
  const cache = self.cache;
  cache.setData(CACHE.MERCHANT_CONFIG, config);
  cache.setData(CONSTANT.TXN_AMOUNT, money(config.data.amount));
  cache.setData(CONSTANT.UNMODIFIED_TXN_AMOUNT, money(config.data.amount));

  if (config.data.tokenType !== _TOKEN.GUEST) {
    cache.setData(CACHE.TOKEN_DATA, {
      token: config.data.token,
      tokenType: config.data.tokenType
    });
    const payoptions = { ...cache.getData(CACHE.PAYMENT_OPTIONS) };

    const isMGV =
      getKey(cache.getData(CONSTANT.CURRENT_PAYMODE), 'paymodeUsed') &&
      getKey(cache.getData(CONSTANT.CURRENT_PAYMODE), 'paymodeUsed').indexOf('GIFT_VOUCHER') > -1;

    /*
     in case of access token since the amount is not priorly known the payment flow is sent which is
     set on merchant so adding a check that if payment flow is received as add and pay then check on
     UI whether txn amount is greater than wallet or not and if txn amount is less than wallet then
     paydata as merchant pay options instead of merchantaddmoney pay options.
     So adding a check just for access token flow as of now so as not to break the existing txn token
     flow for this condition
     */

    if (
      cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW) &&
      getKey(payoptions, 'wallet.isEnabled') &&
      !isInsufficientBalance(payoptions, cache) &&
      isHybridOrAddNPayWithSufficientWalletBalance(payoptions, cache)
    ) {
      payoptions.payData = payoptions.merchantPayOption;
      cache.setData(CACHE.PAYMENT_OPTIONS, payoptions);
    }
    if (
      getKey(payoptions, 'mgv.isEnabled') &&
      isMgvSufficient(payoptions.mgv, cache) &&
      isInsufficientBalance(payoptions, cache) &&
      isMGV
    ) {
      payoptions.wallet && (payoptions.wallet.isUsed = false);
      if (isAddNPay(payoptions, cache)) {
        payoptions.payData = payoptions.addMoneyPayOption;
      } else {
        payoptions.payData = payoptions.merchantPayOption;
      }
      cache.setData(CACHE.PAYMENT_OPTIONS, payoptions);
    }

    if (
      getKey(payoptions, 'wallet.isEnabled') &&
      isInsufficientBalance(payoptions, cache) &&
      !isHybridOrAddNPay(payoptions, cache) &&
      !getKey(payoptions, 'subscriptionDetail.isEnabled', false) &&
      !cache.getData(CONSTANT.IS_LOCAL_STORAGE_ALLOWED)
    ) {
      payoptions.wallet.isUsed = false;
      payoptions.wallet.isEnabled = false;
      const usedPaymode = cache.getData(CONSTANT.CURRENT_PAYMODE);
      if (usedPaymode && !usedPaymode.isWalletCheck) {
        payoptions.wallet.isEnabled = true;
      }
      cache.setData(CACHE.PAYMENT_OPTIONS, payoptions);
    }
    if (
      getKey(payoptions, 'mgv.isEnabled') &&
      isMgvSufficient(payoptions.mgv, cache) &&
      isInsufficientBalance(payoptions, cache) &&
      isMGV
    ) {
      payoptions.wallet && (payoptions.wallet.isUsed = false);
      if (isAddNPay(payoptions, cache)) {
        payoptions.payData = payoptions.addMoneyPayOption;
      } else {
        payoptions.payData = payoptions.merchantPayOption;
      }
      cache.setData(CACHE.PAYMENT_OPTIONS, payoptions);
    }
  }
  if (config.data.tokenType === _TOKEN.GUEST) {
    const rawInstruments = JSON.parse(JSON.stringify(cache.getData(CACHE.RAW_INSTRUMENTS)));
    parseData(rawInstruments);
    cache.setData(CACHE.PAYMENT_OPTIONS, rawInstruments);
  }
  setUpiIntentMwebDisplay(cache);
  self.applyMiddleware(config);
  applyMerchPref(cache.getData(CACHE.PAYMENT_OPTIONS, {}), config);
  const defaultSel = defaultSelected(cache.getData(CACHE.PAYMENT_OPTIONS, {}), cache);
  self.createStoreData(cache.getData(CACHE.PAYMENT_OPTIONS, {}), config, defaultSel);
  log({ eventType: EVENT.INIT, config });
};

const fetchConfigAndPaymodes = (cache, mid, flow) =>
  new Promise(resolve => {
    cache
      .getData(CACHE.API)
      .config(mid)
      .then(mConfig => {
        const iframeEle = document.createElement('iframe');
        const config = mConfig.configuration;
        // if flow default is passed in case of saved config being deferred and flow default is added in initialise
        if (flow === _FLOW.DEFAULT) {
          config.flow = _FLOW.DEFAULT;
        }
        if (config.flow === _FLOW.DEFERRED) {
          if (!config.data) {
            config.data = {};
          }
          config.merchant.mid = mid;
        }
        cache.setData(CACHE.MERCHANT_CONFIG, set(config));
        iframeEle.src = cache.getData(CACHE.API).iframePath();
        iframeEle.id = 'dummy-iframe';
        iframeEle.style.display = 'none';
        document.body.appendChild(iframeEle);
        iframeEle.onload = () => {
          resolve();
        };
      });
  });

const all = promises => {
  return Promise.all(
    promises.map(promise => {
      return Promise.resolve(promise)
        .then(data => {
          return { status: 'fulfilled', value: data };
        })
        .catch(error => {
          return { status: 'rejected', reason: error };
        });
    })
  );
};

/**
 * CheckoutJS constructor
 */
class Checkout {
  api = null;

  constructor(checkoutElementPayMode) {
    this.checkoutElementPayMode = checkoutElementPayMode;
    this.instanceKey = checkoutElementPayMode ? generateUUID() : CONSTANT.DEFAULT_INSTANCE_KEY;
    this.cache = cache.create(this.instanceKey);
    this.setData = callOnce(
      nonMethods.setData.bind(this, this.cache, this.checkoutElementPayMode),
      this
    );
    this.fetchConfigAndPaymodes = fetchConfigAndPaymodes.bind(null, this.cache);
    this.cache.setData(CACHE.CLOSE_HANDLER, this.close.bind(this));
    this.cache.setData(CACHE.CHECKOUT_ELEMENT_PAYMODE, checkoutElementPayMode);
    if (checkoutElementPayMode) {
      this.cache.setData(CACHE.MID, _mid);
      const getData = getKey(cache.getInstance(CONSTANT.DEFAULT_INSTANCE_KEY), 'getData');
      getData && this.cache.setData(CACHE.MERCHANT_CONFIG, { ...getData(CACHE.MERCHANT_CONFIG) });
      this.setAPI();
    }
  }

  /**
   * CheckoutJS initialization method
   * @param {Object} merchantConfiguration - merchant config with which merchant initializes CheckoutJS
   */

  init(merchantConfiguration) {
    const self = this;
    const mConfig = merchantConfiguration;
    /* adding requestId every request */
    if (window.performance) {
      /* adding parseInt since in chrome timeOrigin was giving time with 3 decimal places
       and in firefox it was giving absolute integer */
      mConfig.data.requestId = parseInt(window.performance.timeOrigin, 10).toString();
    } else {
      mConfig.data.requestId = Date.now().toString();
    }

    return new Promise((resolve, reject) => {
      try {
        if (!mConfig) {
          const error = errorObject(ERRORS.ERROR_CODE['4001']);
          log({ eventType: EVENT.MERCHANT_CONFIG_ERROR, config: mConfig, error });
          return reject(error);
        }
        initLogger({ meta: { mid: _mid, orderId: mConfig.data.orderId } });
        if (mConfig.retryData) {
          this.cache.setData(CACHE.RETRY_DATA, mConfig.retryData);
        }
        const tokenType = getKey(mConfig, 'data.tokenType', '');
        const token = getKey(mConfig, 'data.token', '');
        if (tokenType === _TOKEN.ACCESS) {
          log({
            eventType: EVENTS.ACCESS_TOKEN_FLOW_INITIALISED,
            mConfig
          });
          this.cache.setData(CACHE.ACCESS_TOKEN, token);
        }
        if (
          (tokenType === _TOKEN.TXN || tokenType === _TOKEN.ACCESS) &&
          (mConfig && mConfig.flow !== _FLOW.DEFERRED)
        ) {
          const referenceId = getKey(mConfig, 'emiSubvention.referenceId', '');
          const requestId = getKey(mConfig, 'data.requestId', '');
          const instrumentForTxnTokenData = {
            token: getKey(mConfig, 'data.token', ''),
            orderId: getKey(mConfig, 'data.orderId', ''),
            tokenType
          };

          if (referenceId) {
            instrumentForTxnTokenData.referenceId = referenceId;
          }
          if (requestId) {
            instrumentForTxnTokenData.requestId = requestId;
          }
          all([
            getInstrumentForTxnToken(
              this.cache.getData(CACHE.API),
              instrumentForTxnTokenData,
              Boolean(this.checkoutElementPayMode)
            ),
            getDataFromLocalStorage(this.cache)
          ]).then(([instruments, storageObj]) => {
            instruments = cloneObject(instruments.value);
            if (getKey(instruments, 'body.resultInfo.resultCode', '') === '1006') {
              const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
              if (notifyMerchant && notifyMerchant.constructor === Function) {
                log({
                  eventType: CONSTANT.NOTIFY_MERCHANT,
                  eventName: CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED,
                  data: instruments
                });
                notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, instruments);
              }
              reject(errorObject(ERRORS.ERROR_CODE['4002']));
            }

            if (getKey(mConfig, 'emiSubvention', null) && tokenType === _TOKEN.ACCESS) {
              const fallBackAmount = getKey(mConfig, 'data.amount', null);
              this.cache.setData(CONSTANT.FALLBACK_TXN_AMOUNT, fallBackAmount);
              this.cache.setData(CACHE.FALLBACK_TOKEN_DATA, {
                token: mConfig.data.token,
                tokenType: _TOKEN.ACCESS
              });
              const strategyFromConfig = getKey(mConfig, 'emiSubvention.strategy', null);
              this.cache.setData(
                CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW,
                !!getKey(mConfig, 'emiSubvention', null)
              );

              this.cache.setData(CONSTANT.EMISUBVENTION_STATEGY, strategyFromConfig);
              if (strategyFromConfig === _EMI_SUBVENTION_STRATEGY.ITEM_BASED) {
                let items = getKey(mConfig, 'emiSubvention.items', []);
                let miniCart = getKey(mConfig, 'emiSubvention.miniCart', null);
                items = items.map(item => {
                  return {
                    id: item.itemId,
                    productId: item.productId,
                    brandId: item.brandId,
                    categoryList: item.categoryList,
                    quantity: item.quantity,
                    price: item.amount,
                    verticalId: item.verticalId,
                    isEmiEnabled: item.isEmiEnabled,
                    model: item.model,
                    ean: item.ean
                  };
                });
                if (miniCart) {
                  miniCart = miniCart.map(item => {
                    return {
                      id: item.itemId,
                      name: item.name,
                      image: item.imageUrl,
                      price: item.amount,
                      quantity: item.quantity
                    };
                  });
                  this.cache.setData(CONSTANT.SUBVENTION_MINI_CART_OBJ, miniCart);
                }

                this.cache.setData(CONSTANT.SUBVENTION_OBJ, { items });
                /* adding a new initial obj since in case of bank offers the amount has to be updated
                based on discount percentage
                */
                this.cache.setData(CONSTANT.SUBVENTION_OBJ_INITIAL, { items });
              }
              if (strategyFromConfig === _EMI_SUBVENTION_STRATEGY.AMOUNT_BASED) {
                const subventionAmount = getKey(mConfig, 'emiSubvention.subventionAmount', null);
                const totalPrice = getKey(mConfig, 'data.amount', null);
                const obj = {
                  price: totalPrice,
                  subventionAmount
                };
                this.cache.setData(CONSTANT.SUBVENTION_OBJ, obj);
                /* adding a new initial obj since in case of bank offers the amount has to be updated
                based on discount percentage
                */
                this.cache.setData(CONSTANT.SUBVENTION_OBJ_INITIAL, obj);
              }
            }

            if (getKey(instruments, 'body.resultInfo.resultStatus', '') === 'F') {
              reject(errorObject(ERRORS.ERROR_CODE['4003']));
            }

            const paymodes = instruments.body;
            if (getKey(paymodes, 'loginInfo.userLoggedIn', false)) {
              log({ eventType: EVENT.AUTO_LOGIN });
            }
            this.cache.setData(CONSTANT.TXN_AMOUNT, money(mConfig.data.amount));
            const isLocalStorageAccesible = getKey(paymodes, 'isLocalStorageAllowedForLastPayMode');
            if (
              isLocalStorageAccesible &&
              storageObj.status === 'fulfilled' &&
              !this.checkoutElementPayMode
            ) {
              this.cache.setData(CONSTANT.SAVED_PAYMODES, storageObj.value);
              this.cache.setData(CONSTANT.IS_LOGGED_IN, getKey(paymodes, 'loginInfo.userLoggedIn'));
              this.cache.setData(CONSTANT.IS_LOCAL_STORAGE_ALLOWED, true);
              if (this.cache.getData(CONSTANT.IS_LOGGED_IN)) {
                this.cache.setData(CONSTANT.MOBILE_NO, getKey(paymodes.userDetails, 'mobile'));
                processLocalStorage(this.cache);
              }
            }
            this.cache.setData(CONSTANT.ICON_BASE_URL, getKey(paymodes, 'iconBaseUrl', ''));
            parseData(paymodes, this.cache, this.checkoutElementPayMode);
            this.cache.setData(CACHE.PAYMENT_OPTIONS, paymodes);
            /* setting payment offers received in fpo so that after login/logout these can be used  */
            const paymentOffers = getKey(paymodes, 'paymentOffers', []);
            this.cache.setData(CACHE.PAYMENT_OFFERS, paymentOffers);
            _init(mConfig, self);
            resolve();
          });
        } else if (mConfig.flow === _FLOW.DEFERRED) {
          log({
            eventType: EVENTS.DEFERRED_FLOW_INITIALIZED,
            mConfig
          });
          this.cache.setData(CACHE.MERCHANT_CONFIG, set(mConfig, true));
          mConfig.handler
            .deferred(CONSTANT.DEFERRED_EVENTS.FETCH_PAYMODE)
            .then(data => {
              // setting  txn amt received in payload
              const txnAmount = getKey(data, 'paymentInfo.payableAmount.value', 0);
              this.cache.setData(CONSTANT.TXN_AMOUNT, money(txnAmount));
              this.cache.cache.setData(CONSTANT.UNMODIFIED_TXN_AMOUNT, money(txnAmount));
              const mid = getKey(data, 'paymentInfo.mid', mConfig.merchant.mid);
              const merchantName = getKey(
                data,
                'payment_instruments.body.merchantDetails.merchantName',
                mConfig.merchant.name
              );
              mConfig.merchant.mid = mid;
              mConfig.merchant.name = merchantName;
              mConfig.data.amount = txnAmount;
              // setting login info true for deffered flow
              if (data.payment_instruments && data.payment_instruments.body) {
                data.payment_instruments.body.loginInfo = {
                  userLoggedIn: true
                };
              }
              const paymentInstruments = data.payment_instruments.body;
              parseData(paymentInstruments, this.cache, this.checkoutElementPayMode);
              this.cache.setData(CACHE.PAYMENT_OPTIONS, paymentInstruments);
              // setting fallback token data  because txn token has to be removed in retry and sso token has to be stored
              this.cache.setData(CACHE.FALLBACK_TOKEN_DATA, {
                token: mConfig.data.token,
                tokenType: _TOKEN.SSO
              });
              _init(mConfig, self);
              resolve();
            })
            .catch(error => {
              log({
                eventType: CONSTANT.NOTIFY_MERCHANT,
                eventName: CONSTANT.NOTIFY_MERCHANT_EVENTS.FETCH_PAYMENT_OPTIONS_ERROR,
                data: error.message
              });
              notifyMerchant.fetchPaymentError(error.message, this.cache);
              reject(error);
            });
        } else {
          _init(mConfig, self);
          resolve();
        }
      } catch (err) {
        reject(err);
      }
      return null;
    });
  }

  initLib = mid => {
    this.cache.setData(CACHE.MID, mid);
    _mid = mid;
    initLogger({ meta: { mid } });
    this.setAPI();
    return this.fetchConfigAndPaymodes(mid);
  };

  setAPI = () => {
    this.api = new _API(_mid);
    this.api.pay = customPay.bind(this, this.api.pay.bind(this.api), this.cache);
    this.api.getAsyncPayload = getAsyncPayload.bind(
      this,
      this.api.requestPayload.bind(this.api),
      this.cache
    );
    this.api.iframePath = iframePath.bind(this);

    this.api.logger.subscribe('info', data => {
      log(data);
    });

    this.cache.setData(CACHE.API, this.api);
    updateTokens.call(this, this.cache);
  };

  close = () => {
    const config = this.cache.getData(CACHE.MERCHANT_CONFIG, {});
    this.cache.setData(CONSTANT.CURRENT_PAYMODE, null);
    let selector = config.root ? config.root : '#paytm-checkoutjs';
    const globalStoreUnsubscribe = this.cache.getData(CACHE.GLOBAL_STORE_UNSUBSCRIPTION);
    if (globalStoreUnsubscribe) {
      globalStoreUnsubscribe();
      this.cache.setData(CACHE.GLOBAL_STORE_UNSUBSCRIPTION, null);
    }
    selector = document.querySelector(selector);
    if (selector) {
      selector.parentElement.removeChild(selector);
      // TODO: Disbled cache deletion for the moment
      // this.cache.clearInstance(this.instanceKey);
    }
  };

  /**
   * A method to set merchant config incache and invokes middleware for _API interception
   *
   * @param {Object} config - config
   */
  applyMiddleware(config) {
    if (isFunction(this.preMidleWare)) {
      this.preMidleWare();
    }

    if (isFunction(this.postMidleWare)) {
      this.postMidleWare();
    }
    /* check for reference ID and if found add the same in request query for access token */
    const referenceId = getKey(config, 'emiSubvention.referenceId', '');
    this.preMidleWare = this.cache.getData(CACHE.API).middleware.add((o = {}) => {
      const options = o;

      // subscription flow
      const paymentOptions = this.cache.getData(CACHE.PAYMENT_OPTIONS);
      let isSubscriptionFlow = false;
      if (getKey(paymentOptions, 'subscriptionDetail.isEnabled')) {
        options.data.body.subscriptionId = paymentOptions.subscriptionDetail.subsId;
        isSubscriptionFlow = true;
      }
      log({ eventType: EVENT.SUBSCRIPTION_FLOW, value: isSubscriptionFlow });

      const tokenData = this.cache.getData(CACHE.TOKEN_DATA);
      options.data.head.token = tokenData.token;
      options.data.head.tokenType = tokenData.tokenType;
      const accessToken = this.cache.getData(CACHE.ACCESS_TOKEN);
      if (accessToken) {
        options.data.body.accessToken = accessToken;
      }
      if (options.data.body) {
        if (config.merchant && config.merchant.mid) {
          options.data.body.mid = config.merchant.mid;
        }
        if (config.data.orderId) {
          options.data.body.orderId = config.data.orderId;
          options.query.orderId = config.data.orderId;
        }
        if (config.data.requestId) {
          options.data.head.requestId = config.data.requestId;
        }
        if (referenceId) {
          options.query.referenceId = referenceId;
        }
        if (
          options.url.search('/v1/transactionStatus') > -1 &&
          this.cache.getData(CONSTANT.IS_IN_POLLING_STATUS)
        ) {
          options.data.head.version = 'v2';
        }
        if (options.url.search('/api/v1/processTransaction') > -1) {
          const mConfig = this.cache.getData(CACHE.MERCHANT_CONFIG);
          if (isWebViewFlow(mConfig)) {
            mConfig.merchantServerEndpoint = merchantServerEndpoint();
            mConfig.staticPath = getStaticPath();
            mConfig.environment = ENV;
            options.data.body.checkoutJsConfig = encodeURI(
              JSON.stringify(mConfig).replace(/'/g, '')
            ); // this is to remove character from json string in order to avoid json parse error
          }
        }
        options.data.body.paymentFlow = paymentFlow(
          this.cache.getData(CACHE.PAYMENT_OPTIONS, PAYMENT_FLOW.NONE),
          this.cache
        );
      }
      if (!config.data.tokenType) delete options.data.head.type;
      else options.data.head.type = config.data.tokenType;
      return options;
    });

    this.postMidleWare = this.cache.getData(CACHE.API).postFetch.add(option => {
      const { request, response } = option;
      if (
        getKey(response, 'body.txnInfo.RESPCODE', undefined) === '1006' ||
        getKey(response, 'body.resultInfo.resultCode', undefined) === '1006'
      ) {
        // handle the session expired for the user...
        if (getKey(request, 'data.head.tokenType', '') === _TOKEN.GUEST) {
          // call the fetch paymodes api to update the guest token in cache for the GUEST token flow
          this.cache
            .getData(CACHE.API)
            .payModes()
            .then(res => {
              if (getKey(res, 'body.resultInfo.resultStatus', undefined) === 'S') {
                this.cache.setData(CACHE.TOKEN_DATA, {
                  tokenType: _TOKEN.GUEST,
                  token: getKey(res, 'body.guestToken', '')
                });
              }
            });
        } else if (getKey(request, 'data.head.tokenType', '') === _TOKEN.TXN) {
          // call the merchant handler on the expiration of txn token
          const mConfig = this.cache.getData(CACHE.MERCHANT_CONFIG);
          this.cache.getData(CACHE.STORE).setState({ sessionExpired: true });
          const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
          if (notifyMerchant && notifyMerchant.constructor === Function) {
            log({
              eventType: CONSTANT.NOTIFY_MERCHANT,
              eventName: CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED,
              data: response
            });
            notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, response);
          }
        }
        if (request && request.url.search('/api/v1/processTransaction') !== -1) {
          postInWindow(response, this.cache); // in case of session expire then close the popup window
        }
        this.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
      } else if (
        request &&
        request.url &&
        request.url.search('/api/v1/processTransaction') !== -1 &&
        getKey(response, 'body.resultInfo.resultStatus', undefined) === 'F'
      ) {
        postInWindow(response, this.cache);
        if (getKey(response, 'body.resultInfo.retry', undefined) === false) {
          // retry exhausted
          this.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          response.body.content =
            response.body.txnInfo ||
            getKey(response, 'body.bankForm.redirectForm.content', undefined) ||
            {};
          response.body.callbackUrl =
            response.body.callBackUrl ||
            response.body.callbackUrl ||
            getKey(response, 'body.bankForm.redirectForm.actionUrl', undefined) ||
            '';
          handlePostData(response, this.cache);
        } else if (getKey(response, 'body.resultInfo.retry') === true) {
          log({ eventType: EVENT.PAYMENT_RETRY_AVAILABLE });
          // still retry available
          this.cache.getData(CACHE.STORE).setState({
            retryMessage: response.body.resultInfo.resultMsg,
            overlayValue: CONSTANT.RETRY
          });
          // get fallback token from cache and set current token as sso and remove txn token
          const tokenData = this.cache.getData(CACHE.FALLBACK_TOKEN_DATA, {
            token: config.data.token,
            tokenType: _TOKEN.SSO
          });
          this.cache.setData(CACHE.TOKEN_DATA, {
            token: tokenData.token,
            tokenType: tokenData.tokenType
          });
        } else if (
          request &&
          request.url.search('/api/v1/processTransaction') !== -1 &&
          getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S'
        ) {
          const mConfig = this.cache.getData(CACHE.MERCHANT_CONFIG);
          if (isWebViewFlow(mConfig)) {
            const { actionUrl, content } = getKey(response, 'body.bankForm.redirectForm', {});
            response.body.content = content;
            response.body.callbackUrl = actionUrl;
            const form = _getFormHtmlNode(response.body);
            document.body.appendChild(form);
            form.submit();
          }
        }
      } else if (
        (request &&
          request.url.search('/v1/transactionStatus') !== -1 &&
          getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S') ||
        (request &&
          request.url.search('/api/v1/processTransaction') !== -1 &&
          getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S' &&
          (getKey(request, 'data.body.paymentMode', undefined) === CONSTANT.POSTPAID ||
            getKey(request, 'data.body.paymentMode', undefined) === CONSTANT.GIFT_VOUCHER))
      ) {
        savingUsedPaymodeInLocalStorage(this.cache);
      }
      if (
        request &&
        request.url.search('/api/v1/processTransaction') !== -1 &&
        getKey(response, 'body.resultInfo.resultStatus', undefined) === 'S'
      ) {
        const retryCounts = this.cache.getData(CONSTANT.ALLOWED_MERCHANT_RETRY_COUNTS);
        if (!isNullOrUndefined(retryCounts) && retryCounts > 0) {
          this.cache.setData(CONSTANT.ALLOWED_MERCHANT_RETRY_COUNTS, retryCounts - 1);
        } else {
          this.cache.setData(CONSTANT.ALLOWED_MERCHANT_RETRY_COUNTS, 0);
        }
      }
    });
  }

  createStoreData(paymentOptions, mConfig, defaultSelectedValue = null) {
    const store = createStore({
      payData: paymentOptions.payData,
      mgv: paymentOptions.mgv,
      wallet: paymentOptions.wallet,
      AppStyle: mConfig.style,
      payEnabled: true,
      labels: mConfig.labels,
      selected: defaultSelectedValue,
      loginInfo: paymentOptions.loginInfo,
      btnText: '',
      stopScroll: false,
      sessionExpired: false,
      notificationMsg: '',
      cache: this.cache,
      instanceKey: this.instanceKey,
      checkoutElementPayMode: this.checkoutElementPayMode,
      subscription: paymentOptions.subscriptionDetail
    });
    this.cache.setData(CACHE.STORE, store);
  }
}

const checkout = new Checkout();

export const init = checkout.init.bind(checkout);
export const close = checkout.close.bind(checkout);
export const initLib = checkout.initLib.bind(checkout);
export const PAYMODE = _PAYMODE;
export const ELEMENT_PAYMODE = _ELEMENT_PAYMODE;
export const TOKEN = _TOKEN;
export const FLOW = _FLOW;
export const BASE_INSTANCE_KEY = checkout.instanceKey;
export const { DEFERRED_EVENTS, NOTIFY_MERCHANT_EVENTS } = CONSTANT;
export const helpers = {
  fetchPaymentOptions: (...args) => getInstrumentForTxnToken(checkout.api, ...args),
  isObject,
  setMerchantConfig: set,
  getKey,
  getMid: () => _mid
};

export const createInstance = checkoutElementPayMode => {
  const checkoutInstance = new Checkout(checkoutElementPayMode);

  return {
    init: checkoutInstance.init.bind(checkoutInstance),
    close: checkoutInstance.close.bind(checkoutInstance),
    instanceKey: checkoutInstance.instanceKey
  };
};



// WEBPACK FOOTER //
// ./common/checkout.js